import React from 'react';

function Footer() {
  return (
    <div className='footer'>
      <p>
        Designed & Built by{' '}
        <a
          href='https://brianna-workman.netlify.app/'
          target='_blank'
          rel='noopener noreferrer'
        >
          Brianna Workman
        </a>
      </p>
    </div>
  );
}

export default Footer;
